import { SourceSyncStatus } from "@gx/ts-contracts/services/database/models/public_pb";
import { SourceSyncResource } from "@gx/ts-contracts/services/source/resources/source_sync_pb";

const TERMINAL_SYNC_STATUSES = new Set<SourceSyncStatus>([
  SourceSyncStatus.START_FAILED,
  SourceSyncStatus.NORMALIZE_FAILED,
  SourceSyncStatus.EXTRACT_FAILED,
  SourceSyncStatus.LOAD_FAILED,
  SourceSyncStatus.RESEARCH_FAILED,
  SourceSyncStatus.COMPLETE,
  SourceSyncStatus.FAILED,
]);

export function shouldRefetchSourceSyncs(
  refetchInterval: number,
  syncs: SourceSyncResource[] | undefined,
) {
  if (!syncs || syncs.length === 0) {
    return false;
  }

  const hasActiveSync = syncs.some(
    (sync) => !TERMINAL_SYNC_STATUSES.has(sync.syncStatus ?? SourceSyncStatus.UNSPECIFIED),
  );

  return hasActiveSync ? refetchInterval : false;
}
